import type { AllRouteEndpoints } from "../../../../routeTypes";
export const appGroupIdCanvasWorkflowIdStepStepIdMessageMessageVariationIdCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/canvas/:workflow_id/step/:step_id/messages",
];
